import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import * as QueryRepository from "@/components/features/settings/payment-credit/repository/query";

import { SettingsPaymentCreditPresenter } from "./presenter";
import { notifyUserEventInfo } from "../../../../side-effect/notify-user-event-info";

type Props = {
	hotelID: string;
};

export const SettingsPaymentCreditContainer = ({ hotelID }: Props) => {
	const serverModel = QueryRepository.usePaymentCreditQuery(hotelID);

	if (!serverModel || !serverModel.hotel.email) {
		if (!serverModel) {
			notifyUserEventInfo({
				variant: "error",
				title: "データの取得ができませんでした",
			});
		} else {
			notifyUserEventInfo({
				variant: "error",
				title: "先に施設情報の登録を行なってください",
			});
		}

		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <SettingsPaymentCreditPresenter hotelID={hotelID} serverModel={serverModel} />;
};

SettingsPaymentCreditContainer.displayName = "SettingsPaymentCreditContainer";
